import { DOCUMENT } from "@angular/common";
import { Inject, Renderer2 } from "@angular/core";

export class FullscreenComponent {
    constructor(
        protected renderer: Renderer2, 
        @Inject(DOCUMENT) protected document: Document) 
    { }

    protected setAddithonalStyles(destroy: boolean = false) {
        setTimeout(() => {
          let elements = this.document.querySelectorAll('app-standard-content-page .container');

          if(elements && elements.length){
            elements.forEach((element) => {
                if(destroy) {
                  this.renderer.removeStyle(element, 'max-width');
                } else {
                  this.renderer.setStyle(element, 'max-width', 'inherit');
                }
            })
          }
        }, 100);
      }
}